import { render } from "./GoalEdit.vue?vue&type=template&id=d9eb7178"
import script from "./GoalEdit.vue?vue&type=script&lang=js"
export * from "./GoalEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__